import { Component, OnInit } from '@angular/core';
import {NewsService} from '../../services/news/news.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit {

    news: any;
    endpoint: any;

    constructor(
        private newsService: NewsService
    ) {
        const t = this;
        t.endpoint = environment.endpoint;
        this.loadItems();
    }

    ngOnInit(): void {
    }

    loadItems() {
        const t = this;
        this.newsService.get().subscribe((data: any) => {
            t.news = data;
        });
    }

    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }
}
